import { render } from "./MessageBoxControl.vue?vue&type=template&id=25e2a3f2&scoped=true"
import script from "./MessageBoxControl.vue?vue&type=script&lang=js"
export * from "./MessageBoxControl.vue?vue&type=script&lang=js"

import "./MessageBoxControl.vue?vue&type=style&index=0&id=25e2a3f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25e2a3f2"]])

export default __exports__